import React from "react";
import { Container, H1 } from "./style";

export default function Header() {

  return (
    <Container>
      <H1>Kanji Pre-Reader</H1>
    </Container>
  )
}
